module.exports = __webpack_public_path__ + "img/11_8.d101155b.png";